import { PROTECOES_INICIAIS } from '../didatico/manejoVidros'
import { copiarCenaTabletop } from './operacoes'
import type { CenaTabletop } from './tipos'

/**
 * Acidente complexo com obstrução: 3 veículos, multi-triagem.
 * Mantido como preset canônico do sistema para exercícios amplos.
 */
export const PRESET_TABLETOP_COMPLEXO: CenaTabletop = {
  versao: 2,
  nome: 'Acidente complexo com obstrução',
  historiaInicial: 'A equipe encontra três veículos envolvidos em um acidente, incluindo um capotado e outro apoiado sobre ele. Há pessoas no interior e obstáculos ao redor dos veículos.',
  objetos: [
    {
      id: 'preset-carro-capotado',
      tipo: 'carro',
      nome: 'Veículo capotado',
      cor: '#374151',
      transformacao: {
        posicao: [0, 0.9, 0],
        rotacao: [Math.PI, 0.18, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'hatchCompacto',
        posicaoFinal: 'capotado',
        estadosPecas: {},
        vidros: { parabrisa: 'quebrado' },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
      },
    },
    {
      id: 'preset-vitima-capotado-motorista',
      tipo: 'vitima',
      nome: 'Motorista — capotado',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        triagem: 'vermelho',
        colarCervical: true,
        local: { tipo: 'veiculo', idVeiculo: 'preset-carro-capotado', idAncora: 'motorista' },
      },
    },
    {
      id: 'preset-vitima-capotado-passageiro',
      tipo: 'vitima',
      nome: 'Passageiro — capotado',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        triagem: 'amarelo',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'preset-carro-capotado', idAncora: 'passageiro' },
      },
    },
    {
      id: 'preset-carro-apoiado',
      tipo: 'carro',
      nome: 'Veículo tombado sobre o primeiro',
      cor: '#b91c1c',
      transformacao: {
        posicao: [0.7, 2.15, 0.15],
        rotacao: [0.12, -0.28, Math.PI / 2],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'hatchCompacto',
        posicaoFinal: 'tombadoDireito',
        estadosPecas: {},
        vidros: {},
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
      },
    },
    {
      id: 'preset-vitima-tombado-traseiro',
      tipo: 'vitima',
      nome: 'Passageiro traseiro — tombado',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'idoso',
        triagem: 'preto',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'preset-carro-apoiado', idAncora: 'traseiroCentral' },
      },
    },
    {
      id: 'preset-carro-normal',
      tipo: 'suv',
      nome: 'SUV em posição normal',
      cor: '#d1d5db',
      transformacao: {
        posicao: [4.4, 0, 0.8],
        rotacao: [0, -0.25, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'sedanMedio',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: { portaDianteiraEsquerda: 'quebrado' },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
      },
    },
    {
      id: 'preset-vitima-suv',
      tipo: 'vitima',
      nome: 'Motorista — SUV',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        triagem: 'verde',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'preset-carro-normal', idAncora: 'motorista' },
      },
    },
    {
      id: 'preset-arvore',
      tipo: 'arvore',
      nome: 'Árvore obstruindo a saída',
      transformacao: {
        posicao: [2.1, 0, -0.3],
        rotacao: [0, 0, -0.18],
        escala: [1.1, 1.1, 1.1],
      },
    },
    {
      id: 'preset-defensa',
      tipo: 'defensa',
      nome: 'Defensa metálica',
      transformacao: {
        posicao: [-2.7, 0, -2],
        rotacao: [0, Math.PI / 2, 0],
        escala: [1.8, 1, 1],
      },
    },
    {
      id: 'preset-cone-1',
      tipo: 'cone',
      nome: 'Cone 1',
      transformacao: {
        posicao: [-3, 0, 2.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'preset-cone-2',
      tipo: 'cone',
      nome: 'Cone 2',
      transformacao: {
        posicao: [-1.5, 0, 2.5],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'preset-vitima-ejetada',
      tipo: 'vitima',
      nome: 'Vítima ejetada — acesso obstruído',
      transformacao: {
        posicao: [1.55, 0, -0.25],
        rotacao: [0, 0, Math.PI / 2],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        triagem: 'vermelho',
        colarCervical: false,
        prioridadeManual: 2,
        local: { tipo: 'solo', postura: 'decubitoDorsal' },
      },
    },
    {
      id: 'preset-detritos-vidro',
      tipo: 'detritosVidro',
      nome: 'Fragmentos de vidro na zona de acesso',
      cor: '#a5f3fc',
      transformacao: {
        posicao: [2.65, 0.02, 0.9],
        rotacao: [0, -0.2, 0],
        escala: [1.4, 1, 1.1],
      },
    },
    {
      id: 'preset-calco-1',
      tipo: 'calco',
      nome: 'Calço — coluna A esquerda (SUV)',
      transformacao: {
        posicao: [3.6, 0, 0.3],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
  ],
}

/**
 * Cenário 1: Colisão Frontal contra Muro com Encarceramento Mecânico.
 */
export const PRESET_CENARIO_1_COLISAO_MURO: CenaTabletop = {
  versao: 2,
  historiaInicial: 'Um sedã colidiu contra um muro de concreto. Há uma pessoa no interior do veículo.',
  nome: 'Cenário 1: Colisão Frontal contra Muro',
  objetos: [
    {
      id: 'slide-49-carro',
      tipo: 'carro',
      nome: 'Sedã colidido (Impacto Frontal)',
      cor: '#1e3a8a',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'sedanMedio',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: { parabrisa: 'quebrado' },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'frente',
          nivel: 'severo',
          intrusaoM: 0.42,
          larguraM: 1.6,
        },
        deformacoes: [
          {
            regiao: 'frente',
            nivel: 'severo',
            intrusaoM: 0.42,
            larguraM: 1.6,
          },
          {
            regiao: 'lateralEsquerda',
            nivel: 'moderado',
            intrusaoM: 0.22,
            larguraM: 0.8,
            idPorta: 'portaDianteiraEsquerda',
            centroFaceM: 0.35,
          },
        ],
      },
    },
    {
      id: 'cenario-1-muro',
      tipo: 'muro',
      nome: 'Muro de concreto rígido',
      transformacao: {
        posicao: [0, 0, 2.48],
        rotacao: [0, 0, 0],
        escala: [1.2, 1, 1],
      },
    },
    {
      id: 'slide_49_v1_motorista',
      tipo: 'vitima',
      nome: 'V1 — Motorista',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        fichaAtendimentoId: 'slide_49_v1_motorista',
        triagem: 'vermelho',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'slide-49-carro', idAncora: 'motorista' },
      },
    },
    {
      id: 'cenario-1-oleo',
      tipo: 'derramamento',
      nome: 'Vazamento de combustível e óleo sob o motor',
      cor: '#b45309',
      transformacao: {
        posicao: [-0.4, 0.012, 1.3],
        rotacao: [0, 0, 0],
        escala: [1.6, 1, 1.6],
      },
      risco: {
        vazamentoAtivo: true,
        materiaisAceitos: ['serragem', 'areia', 'absorvente_industrial'],
      },
    },
    {
      id: 'cenario-1-vidros',
      tipo: 'detritosVidro',
      nome: 'Estilhaços de vidro temperado e laminado',
      cor: '#bae6fd',
      transformacao: {
        posicao: [0.7, 0.012, 1.4],
        rotacao: [0, 0.15, 0],
        escala: [1.5, 1, 1.5],
      },
    },
    {
      id: 'slide-49-calco-dianteiro',
      tipo: 'calco',
      nome: 'Calço dianteiro esquerdo',
      transformacao: {
        posicao: [-0.8, 0, 1.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
    {
      id: 'slide-49-calco-traseiro',
      tipo: 'calco',
      nome: 'Calço traseiro esquerdo',
      transformacao: {
        posicao: [-0.8, 0, -1.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
    {
      id: 'slide-49-cone-1',
      tipo: 'cone',
      nome: 'Cone de sinalização 1',
      transformacao: {
        posicao: [-2.8, 0, 3.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'slide-49-cone-2',
      tipo: 'cone',
      nome: 'Cone de sinalização 2',
      transformacao: {
        posicao: [2.8, 0, 3.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}
export const PRESET_SLIDE_49_CHOQUE_FRONTAL = PRESET_CENARIO_1_COLISAO_MURO

/**
 * Cenário 2: Colisão Lateral entre Dois Veículos (T-Bone em Cruzamento).
 */
export const PRESET_CENARIO_2_COLISAO_LATERAL: CenaTabletop = {
  versao: 2,
  historiaInicial: 'Dois veículos colidiram lateralmente em um cruzamento. Há pessoas nos veículos e danos nas portas.',
  nome: 'Cenário 2: Colisão Lateral entre Dois Veículos',
  objetos: [
    {
      id: 'slide-51-carro',
      tipo: 'carro',
      nome: 'Sedã abalroado (Impacto Lateral)',
      cor: '#831843',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0.15, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'sedanMedio',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: {
          portaDianteiraDireita: 'quebrado',
          portaTraseiraDireita: 'quebrado',
        },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'lateralDireita',
          nivel: 'severo',
          intrusaoM: 0.36,
          larguraM: 1.5,
        },
        deformacoes: [
          {
            regiao: 'lateralDireita',
            nivel: 'severo',
            intrusaoM: 0.36,
            larguraM: 1.5,
            idPorta: 'portaDianteiraDireita',
          },
          {
            regiao: 'lateralEsquerda',
            nivel: 'leve',
            intrusaoM: 0.12,
            larguraM: 0.7,
            idPorta: 'portaDianteiraEsquerda',
          },
        ],
      },
    },
    {
      id: 'cenario-2-suv-colisor',
      tipo: 'suv',
      nome: 'SUV colisor (Impacto Lateral T-Bone)',
      cor: '#475569',
      transformacao: {
        posicao: [2.35, 0, 0.15],
        rotacao: [0, -Math.PI / 2 + 0.15, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'sedanMedio',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: { parabrisa: 'quebrado' },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'frente',
          nivel: 'severo',
          intrusaoM: 0.35,
          larguraM: 1.5,
        },
      },
    },
    {
      id: 'slide_51_v1_motorista',
      tipo: 'vitima',
      nome: 'V1 — Motorista',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        fichaAtendimentoId: 'slide_51_v1_motorista',
        triagem: 'amarelo',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'slide-51-carro', idAncora: 'motorista' },
      },
    },
    {
      id: 'slide_51_v2_passageiro',
      tipo: 'vitima',
      nome: 'V2 — Passageiro',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        fichaAtendimentoId: 'slide_51_v2_passageiro',
        triagem: 'vermelho',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'slide-51-carro', idAncora: 'passageiro' },
      },
    },
    {
      id: 'cenario-2-oleo',
      tipo: 'derramamento',
      nome: 'Vazamento de fluídos de arrefecimento e óleo',
      cor: '#374151',
      transformacao: {
        posicao: [1.2, 0.01, 0.1],
        rotacao: [0, 0, 0],
        escala: [2.0, 1, 1.8],
      },
      risco: {
        vazamentoAtivo: true,
        materiaisAceitos: ['serragem', 'areia', 'absorvente_industrial'],
      },
    },
    {
      id: 'cenario-2-vidros',
      tipo: 'detritosVidro',
      nome: 'Fragmentos de vidro na zona de impacto',
      cor: '#a5f3fc',
      transformacao: {
        posicao: [1.1, 0.01, -0.6],
        rotacao: [0, 0, 0],
        escala: [1.6, 1, 1.5],
      },
    },
    {
      id: 'slide-51-calco-1',
      tipo: 'calco',
      nome: 'Calço lateral',
      transformacao: {
        posicao: [-0.9, 0, 0.8],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
    {
      id: 'slide-51-cunha-1',
      tipo: 'cunha',
      nome: 'Cunha de pneu',
      transformacao: {
        posicao: [-0.9, 0, -1.0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'cunha' },
    },
    {
      id: 'slide-51-cone-1',
      tipo: 'cone',
      nome: 'Cone de isolamento 1',
      transformacao: {
        posicao: [-3.2, 0, 2.5],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'slide-51-cone-2',
      tipo: 'cone',
      nome: 'Cone de isolamento 2',
      transformacao: {
        posicao: [3.8, 0, 2.8],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}
export const PRESET_SLIDE_51_DUAS_VITIMAS = PRESET_CENARIO_2_COLISAO_LATERAL

/**
 * Cenário 3: Capotamento com Vítima Ejetada no Solo e Ocupante Retida.
 */
export const PRESET_CENARIO_3_CAPOTAMENTO: CenaTabletop = {
  versao: 2,
  historiaInicial: 'Um veículo capotou e atingiu uma defensa. A equipe encontra uma pessoa no solo e outra no interior.',
  nome: 'Cenário 3: Capotamento com Vítima Ejetada',
  objetos: [
    {
      id: 'capotamento-carro',
      tipo: 'carro',
      nome: 'Hatch Invertido (Capotado)',
      cor: '#dc2626',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0.35, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'hatchCompacto',
        posicaoFinal: 'capotado',
        estadosPecas: {},
        vidros: {
          parabrisa: 'quebrado',
          portaDianteiraEsquerda: 'quebrado',
          portaDianteiraDireita: 'quebrado',
          vigiaTraseiro: 'quebrado',
        },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'teto',
          nivel: 'severo',
          intrusaoM: 0.28,
          larguraM: 1.4,
        },
        deformacoes: [
          {
            regiao: 'teto',
            nivel: 'severo',
            intrusaoM: 0.28,
            larguraM: 1.4,
          },
          {
            regiao: 'lateralEsquerda',
            nivel: 'moderado',
            intrusaoM: 0.18,
            larguraM: 0.9,
            idPorta: 'portaDianteiraEsquerda',
          },
          {
            regiao: 'lateralDireita',
            nivel: 'moderado',
            intrusaoM: 0.18,
            larguraM: 0.9,
            idPorta: 'portaDianteiraDireita',
          },
        ],
      },
    },
    {
      id: 'capotamento-defensa',
      tipo: 'defensa',
      nome: 'Defensa metálica deformada',
      transformacao: {
        posicao: [-2.6, 0, -1.8],
        rotacao: [0, 0.3, 0],
        escala: [1.5, 1, 1],
      },
    },
    {
      id: 'capotamento_v1_ejetada',
      tipo: 'vitima',
      nome: 'V1 — Ejetada no Solo (Crítica / TCE)',
      transformacao: {
        posicao: [3.4, 0, 1.2],
        rotacao: [0, -0.3, Math.PI / 2],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        fichaAtendimentoId: 'capotamento_ejetada_solo',
        triagem: 'vermelho',
        colarCervical: false,
        local: { tipo: 'solo', postura: 'decubitoDorsal' },
      },
    },
    {
      id: 'capotamento_v2_interna',
      tipo: 'vitima',
      nome: 'V2 — Condutora no Veículo (Estável)',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        fichaAtendimentoId: 'capotamento_ocupante_veiculo',
        triagem: 'amarelo',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'capotamento-carro', idAncora: 'motorista' },
      },
    },
    {
      id: 'capotamento-derramamento',
      tipo: 'derramamento',
      nome: 'Derramamento de combustível',
      cor: '#374151',
      transformacao: {
        posicao: [-0.6, 0.01, -0.4],
        rotacao: [0, 0, 0],
        escala: [1.8, 1, 1.8],
      },
      risco: {
        vazamentoAtivo: true,
        materiaisAceitos: ['serragem', 'areia', 'absorvente_industrial'],
      },
    },
    {
      id: 'capotamento-detritos-vidro',
      tipo: 'detritosVidro',
      nome: 'Estilhaços de vidro na pista',
      cor: '#a5f3fc',
      transformacao: {
        posicao: [1.6, 0.01, 0.5],
        rotacao: [0, 0.2, 0],
        escala: [1.8, 1, 1.4],
      },
    },
    {
      id: 'capotamento-cone-1',
      tipo: 'cone',
      nome: 'Cone de sinalização 1',
      transformacao: {
        posicao: [-3.5, 0, 2.8],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'capotamento-cone-2',
      tipo: 'cone',
      nome: 'Cone de sinalização 2',
      transformacao: {
        posicao: [4.8, 0, 2.6],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}
export const PRESET_CAPOTAMENTO_EJETADA = PRESET_CENARIO_3_CAPOTAMENTO

/**
 * Cenário 4: Carro Sobre Outro Veículo — Estabilização Pesada.
 */
export const PRESET_CENARIO_4_CARRO_SOBRE_OUTRO: CenaTabletop = {
  versao: 2,
  historiaInicial: 'Dois veículos estão sobrepostos após uma colisão. Há pessoas no veículo inferior e no superior.',
  nome: 'Cenário 4: Carro Sobre Outro Veículo',
  objetos: [
    {
      id: 'cenario-4-carro-inferior',
      tipo: 'carro',
      nome: 'Veículo inferior (Sob a carga)',
      cor: '#334155',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'sedanMedio',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: {
          vigiaTraseiro: 'quebrado',
          portaTraseiraDireita: 'quebrado',
        },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'teto',
          nivel: 'severo',
          intrusaoM: 0.32,
          larguraM: 1.4,
        },
        deformacoes: [
          {
            regiao: 'teto',
            nivel: 'severo',
            intrusaoM: 0.32,
            larguraM: 1.4,
          },
          {
            regiao: 'lateralEsquerda',
            nivel: 'moderado',
            intrusaoM: 0.22,
            larguraM: 0.8,
            idPorta: 'portaDianteiraEsquerda',
          },
        ],
      },
    },
    {
      id: 'cenario-4-carro-superior',
      tipo: 'carro',
      nome: 'Veículo superior (Encavalado instável)',
      cor: '#b91c1c',
      transformacao: {
        posicao: [0.35, 1.35, -0.2],
        rotacao: [0.18, -0.22, 0.45],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'hatchCompacto',
        posicaoFinal: 'sobreOutroVeiculo',
        estadosPecas: {},
        vidros: {
          parabrisa: 'quebrado',
          portaDianteiraDireita: 'quebrado',
        },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'frente',
          nivel: 'severo',
          intrusaoM: 0.3,
          larguraM: 1.2,
        },
        deformacoes: [
          {
            regiao: 'frente',
            nivel: 'severo',
            intrusaoM: 0.3,
            larguraM: 1.2,
          },
          {
            regiao: 'lateralDireita',
            nivel: 'severo',
            intrusaoM: 0.28,
            larguraM: 0.9,
            idPorta: 'portaDianteiraDireita',
          },
        ],
      },
    },
    {
      id: 'cenario-4-vstrut-esquerdo',
      tipo: 'vstrut',
      nome: 'V-Strut lateral esquerdo (Base no solo -> Cabeça no carro a escorar)',
      transformacao: {
        posicao: [-1.2, 0, -0.3],
        rotacao: [0, 0.25, 0],
        escala: [1, 1, 1],
      },
      equipamento: {
        tipo: 'vstrut',
        alcance: [1.35, 1.35, 0.1],
      },
    },
    {
      id: 'cenario-4-vstrut-traseiro',
      tipo: 'vstrut',
      nome: 'V-Strut traseiro (Base no solo -> Cabeça no carro a escorar)',
      transformacao: {
        posicao: [0.35, 0, -2.0],
        rotacao: [0, Math.PI / 2, 0],
        escala: [1, 1, 1],
      },
      equipamento: {
        tipo: 'vstrut',
        alcance: [-0.05, 1.35, 1.6],
      },
    },
    {
      id: 'cenario-4-fita-catraca',
      tipo: 'fitaCatraca',
      nome: 'Fita Catraca de Amarração (Une os dois carros em bloco preso)',
      transformacao: {
        posicao: [0.85, 0.55, -0.2],
        rotacao: [0, 0, 0.3],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'fitaCatraca' },
    },
    {
      id: 'cenario-4-calco-1',
      tipo: 'calco',
      nome: 'Calço sob longarina do carro inferior',
      transformacao: {
        posicao: [-0.9, 0, 0.9],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
    {
      id: 'cenario-4-bloco-1',
      tipo: 'bloco',
      nome: 'Bloco de apoio cribbing',
      transformacao: {
        posicao: [0.9, 0, -0.9],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'bloco' },
    },
    {
      id: 'sobre_outro_v1_inferior',
      tipo: 'vitima',
      nome: 'V1 — Condutor Inferior (Sob a Carga / Crítico)',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        fichaAtendimentoId: 'sobre_outro_v1_inferior',
        triagem: 'vermelho',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'cenario-4-carro-inferior', idAncora: 'motorista' },
      },
    },
    {
      id: 'sobre_outro_v2_superior',
      tipo: 'vitima',
      nome: 'V2 — Ocupante Superior (Elevado / Estável)',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        fichaAtendimentoId: 'sobre_outro_v2_superior',
        triagem: 'amarelo',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'cenario-4-carro-superior', idAncora: 'motorista' },
      },
    },
    {
      id: 'cenario-4-derramamento',
      tipo: 'derramamento',
      nome: 'Vazamento de fluidos de ambos os veículos',
      cor: '#374151',
      transformacao: {
        posicao: [0.2, 0.01, -0.4],
        rotacao: [0, 0, 0],
        escala: [2.2, 1, 2.0],
      },
      risco: {
        vazamentoAtivo: true,
        materiaisAceitos: ['serragem', 'areia', 'absorvente_industrial'],
      },
    },
    {
      id: 'cenario-4-vidros',
      tipo: 'detritosVidro',
      nome: 'Estilhaços e vidros sob tensão',
      cor: '#a5f3fc',
      transformacao: {
        posicao: [1.2, 0.01, 0.8],
        rotacao: [0, 0, 0],
        escala: [1.8, 1, 1.6],
      },
    },
    {
      id: 'cenario-4-cone-1',
      tipo: 'cone',
      nome: 'Cone de isolamento da zona quente 1',
      transformacao: {
        posicao: [-3.5, 0, 3.0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cenario-4-cone-2',
      tipo: 'cone',
      nome: 'Cone de isolamento da zona quente 2',
      transformacao: {
        posicao: [3.5, 0, 3.0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}
export const PRESET_CARRO_SOBRE_OUTRO = PRESET_CENARIO_4_CARRO_SOBRE_OUTRO

/**
 * Cenário 5: Colisão com Duas Vítimas Estáveis (Retirada Alinhada a 0°).
 */
export const PRESET_CENARIO_5_DUAS_ESTAVEIS: CenaTabletop = {
  versao: 2,
  historiaInicial: 'Um sedã colidiu contra uma defensa. Duas pessoas permanecem no interior, com as portas deformadas.',
  nome: 'Cenário 5: Colisão com Duas Vítimas Estáveis',
  objetos: [
    {
      id: 'slide-53-carro',
      tipo: 'carro',
      nome: 'Sedã (Desaceleração Frontal com Portas Emperradas)',
      cor: '#0284c7',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'sedanMedio',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: {},
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'frente',
          nivel: 'moderado',
          intrusaoM: 0.22,
          larguraM: 1.3,
        },
        deformacoes: [
          {
            regiao: 'frente',
            nivel: 'moderado',
            intrusaoM: 0.22,
            larguraM: 1.3,
          },
          {
            regiao: 'lateralEsquerda',
            nivel: 'leve',
            intrusaoM: 0.12,
            larguraM: 0.7,
            idPorta: 'portaDianteiraEsquerda',
          },
          {
            regiao: 'lateralDireita',
            nivel: 'leve',
            intrusaoM: 0.12,
            larguraM: 0.7,
            idPorta: 'portaDianteiraDireita',
          },
        ],
      },
    },
    {
      id: 'slide-53-defensa',
      tipo: 'defensa',
      nome: 'Defensa metálica de contenção',
      transformacao: {
        posicao: [0, 0, 2.2],
        rotacao: [0, 0, 0],
        escala: [1.6, 1, 1],
      },
    },
    {
      id: 'slide_53_v1_motorista',
      tipo: 'vitima',
      nome: 'V1 — Motorista',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        fichaAtendimentoId: 'slide_53_v1_motorista',
        triagem: 'verde',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'slide-53-carro', idAncora: 'motorista' },
      },
    },
    {
      id: 'slide_53_v2_passageiro',
      tipo: 'vitima',
      nome: 'V2 — Passageiro',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        fichaAtendimentoId: 'slide_53_v2_passageiro',
        triagem: 'verde',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'slide-53-carro', idAncora: 'passageiro' },
      },
    },
    {
      id: 'slide-53-derramamento',
      tipo: 'derramamento',
      nome: 'Fluido de arrefecimento e óleo vazado',
      cor: '#334155',
      transformacao: {
        posicao: [0, 0.01, 1.1],
        rotacao: [0, 0, 0],
        escala: [1.4, 1, 1.4],
      },
      risco: {
        vazamentoAtivo: false,
        materiaisAceitos: ['serragem', 'areia', 'absorvente_industrial'],
      },
    },
    {
      id: 'slide-53-vidros',
      tipo: 'detritosVidro',
      nome: 'Fragmentos de faróis e policarbonato na via',
      cor: '#a5f3fc',
      transformacao: {
        posicao: [-0.6, 0.01, 1.4],
        rotacao: [0, 0, 0],
        escala: [1.2, 1, 1.2],
      },
    },
    {
      id: 'slide-53-calco-1',
      tipo: 'calco',
      nome: 'Calço dianteiro',
      transformacao: {
        posicao: [-0.85, 0, 1.1],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
    {
      id: 'slide-53-calco-2',
      tipo: 'calco',
      nome: 'Calço traseiro',
      transformacao: {
        posicao: [0.85, 0, -1.1],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      equipamento: { tipo: 'calco' },
    },
    {
      id: 'slide-53-cone-1',
      tipo: 'cone',
      nome: 'Cone de sinalização 1',
      transformacao: {
        posicao: [-2.6, 0, 3.0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'slide-53-cone-2',
      tipo: 'cone',
      nome: 'Cone de sinalização 2',
      transformacao: {
        posicao: [2.6, 0, 3.0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}
export const PRESET_SLIDE_53_DUAS_ESTAVEIS = PRESET_CENARIO_5_DUAS_ESTAVEIS

/**
 * Cenário 6: Atropelamento e Choque em Poste (Hemorragia Crítica & Risco Elétrico).
 */
export const PRESET_CENARIO_6_ATROPELAMENTO: CenaTabletop = {
  versao: 2,
  historiaInicial: 'Um veículo atropelou uma pessoa e atingiu um poste. A equipe encontra uma pessoa no solo e um cabo caído na via.',
  nome: 'Atropelamento — hemorragia em coxa',
  acionamento: {
    natureza: 'atropelamento',
    local: '',
    horario: '',
    recursos: '',
    informacoes: [
      { id: 'info-pessoa-caida', texto: 'pessoa caída na via', confirmado: false, visivel: true },
      { id: 'info-sangramento', texto: 'possível sangramento', confirmado: false, visivel: true },
      { id: 'info-veiculo', texto: 'veículo envolvido parado no local', confirmado: false, visivel: false },
    ],
  },
  objetos: [
    {
      id: 'atropelamento-carro',
      tipo: 'carro',
      nome: 'Hatch envolvido no atropelamento',
      cor: '#b91c1c',
      transformacao: {
        posicao: [0, 0, -2.2],
        rotacao: [0, 0.35, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'hatchCompacto',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {},
        vidros: { parabrisa: 'quebrado' },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
        deformacao: {
          regiao: 'frente',
          nivel: 'leve',
          intrusaoM: 0.08,
          larguraM: 0.9,
        },
        deformacoes: [
          {
            regiao: 'frente',
            nivel: 'leve',
            intrusaoM: 0.08,
            larguraM: 0.9,
          },
          {
            regiao: 'lateralEsquerda',
            nivel: 'leve',
            intrusaoM: 0.08,
            idPorta: 'portaDianteiraEsquerda',
          },
        ],
      },
    },
    {
      id: 'atropelamento-vitima',
      tipo: 'vitima',
      nome: 'Pedestre',
      transformacao: {
        posicao: [0.6, 0, 1.8],
        rotacao: [0, 0.4, Math.PI / 2],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoFeminino',
        fichaAtendimentoId: 'vitima9',
        triagem: 'vermelho',
        colarCervical: false,
        local: { tipo: 'solo', postura: 'decubitoDorsal' },
      },
    },
    {
      id: 'atropelamento-detritos',
      tipo: 'detritosVidro',
      nome: 'Fragmentos de vidro na via',
      transformacao: {
        posicao: [-0.4, 0, 0.3],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'atropelamento-oleo',
      tipo: 'derramamento',
      nome: 'Mancha de óleo sob o carro',
      transformacao: {
        posicao: [-0.2, 0, -0.6],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      risco: { vazamentoAtivo: true, materiaisAceitos: ['serragem', 'areia', 'absorvente_industrial'] },
    },
    {
      id: 'atropelamento-poste',
      tipo: 'poste',
      nome: 'Poste atingido',
      transformacao: {
        posicao: [3.4, 0, -1.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'atropelamento-cabo',
      tipo: 'caboEletrico',
      nome: 'Cabo energizado caído',
      transformacao: {
        posicao: [3.1, 0, 0.4],
        rotacao: [0, -0.5, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'atropelamento-cone-1',
      tipo: 'cone',
      nome: 'Cone de sinalização 1',
      transformacao: {
        posicao: [-2.6, 0, 3.2],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'atropelamento-cone-2',
      tipo: 'cone',
      nome: 'Cone de sinalização 2',
      transformacao: {
        posicao: [2.8, 0, 3.4],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}
export const PRESET_ATROPELAMENTO_HEMORRAGIA = PRESET_CENARIO_6_ATROPELAMENTO

/**
 * Cenário 7: Barreira de Proteção Rodoviária (45° a 15m)
 *
 * Doutrina operacional CBMMG / Salvamento Veicular em Rodovias:
 * - Viatura pesada (ABT) a 45° a 15m a montante do sinistro
 * - Luzes de emergência/giroflex ligados para alerta precoce
 * - Cone de transição para desvio progressivo do fluxo da pista
 * - Espaço livre reservado para a chegada e manobra da USA (Suporte Avançado)
 * - Bombeiro com EPI completo (sem EPR para agilidade) e Bombeiro Médico com O2 e kit trauma
 */
export const PRESET_CENARIO_7_BARREIRA_PROTECAO: CenaTabletop = {
  versao: 2,
  historiaInicial: 'A equipe organiza uma ocorrência em rodovia, posicionando a viatura, cones e área de apoio para o atendimento.',
  nome: 'Cenário 7: Barreira de Proteção Rodoviária (45° a 15m)',
  objetos: [
    {
      id: 'cen7-caminhao-bombeiros',
      tipo: 'caminhaoBombeiros',
      nome: 'ABT — Barreira 45° a 15m',
      cor: '#dc2626',
      transformacao: {
        posicao: [0.8, 0, -15],
        rotacao: [0, -Math.PI / 4, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-area-usa',
      tipo: 'areaUsa',
      nome: 'Espaço Livre USA (Suporte Avançado)',
      transformacao: {
        posicao: [-2.4, 0, -5],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-cone-transicao-1',
      tipo: 'cone',
      nome: 'Cone de transição 1',
      transformacao: {
        posicao: [-3.2, 0, -32],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-cone-transicao-2',
      tipo: 'cone',
      nome: 'Cone de transição 2',
      transformacao: {
        posicao: [-2.4, 0, -27],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-cone-transicao-3',
      tipo: 'cone',
      nome: 'Cone de transição 3',
      transformacao: {
        posicao: [-1.4, 0, -22],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-cone-transicao-4',
      tipo: 'cone',
      nome: 'Cone de transição 4',
      transformacao: {
        posicao: [-0.4, 0, -18],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-cone-transicao-5',
      tipo: 'cone',
      nome: 'Cone de transição 5',
      transformacao: {
        posicao: [0.8, 0, -14],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-cone-transicao-6',
      tipo: 'cone',
      nome: 'Cone de transição 6',
      transformacao: {
        posicao: [2.0, 0, -10],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-veiculo-sinistrado',
      tipo: 'carro',
      nome: 'Veículo sinistrado protegido',
      cor: '#1e3a8a',
      transformacao: {
        posicao: [1.2, 0, 0],
        rotacao: [0, 0.12, 0],
        escala: [1, 1, 1],
      },
      veiculo: {
        idPerfil: 'hatchCompacto',
        posicaoFinal: 'sobreRodas',
        estadosPecas: {
          portaDianteiraEsquerda: 'aberta',
        },
        vidros: { parabrisa: 'quebrado' },
        insulfilm: false,
        protecoes: { ...PROTECOES_INICIAIS },
      },
    },
    {
      id: 'cen7-vitima-condutor',
      tipo: 'vitima',
      nome: 'Condutor retido',
      transformacao: {
        posicao: [0, 0, 0],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
      vitima: {
        idPerfil: 'adultoMasculino',
        triagem: 'vermelho',
        colarCervical: false,
        local: { tipo: 'veiculo', idVeiculo: 'cen7-veiculo-sinistrado', idAncora: 'motorista' },
        fichaAtendimentoId: 'vitima1',
      },
    },
    {
      id: 'cen7-bombeiro-salvamento',
      tipo: 'bombeiro',
      nome: 'Bombeiro (EPI Incêndio)',
      transformacao: {
        posicao: [0.1, 0, 0.7],
        rotacao: [0, Math.PI / 2, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-bombeiro-medico',
      tipo: 'bombeiroMedico',
      nome: 'Bombeiro Médico (APH / Kit O2)',
      transformacao: {
        posicao: [-0.4, 0, -0.6],
        rotacao: [0, 0.45, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-calco-1',
      tipo: 'calco',
      nome: 'Calço roda traseira',
      transformacao: {
        posicao: [0.25, 0, 1.3],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
    {
      id: 'cen7-calco-2',
      tipo: 'calco',
      nome: 'Calço roda dianteira',
      transformacao: {
        posicao: [0.25, 0, -1.3],
        rotacao: [0, 0, 0],
        escala: [1, 1, 1],
      },
    },
  ],
}

export interface PredefinicaoTabletop {
  readonly id: string
  readonly titulo: string
  readonly descricao: string
  readonly vitimasRotulo: string
  readonly criarCena: () => CenaTabletop
}

export const PRESETS_TABLETOP: readonly PredefinicaoTabletop[] = [
  {
    id: 'cenario-1',
    titulo: 'Cenário 1: Colisão Frontal contra Muro',
    descricao: 'Sedã colidido contra barreira de concreto rígido. Condutor crítico retido pelo painel com choque hipovolêmico.',
    vitimasRotulo: '1 vítima (Crítica / Vermelho)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_1_COLISAO_MURO),
  },
  {
    id: 'cenario-2',
    titulo: 'Cenário 2: Colisão Lateral entre Dois Veículos',
    descricao: 'Impacto T-Bone em cruzamento entre sedã e SUV. Dilema de acesso: V1 motorista preso por pedais vs V2 passageira com intrusão severa.',
    vitimasRotulo: '2 vítimas (1 Vermelho, 1 Amarelo)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_2_COLISAO_LATERAL),
  },
  {
    id: 'cenario-3',
    titulo: 'Cenário 3: Capotamento com Vítima Ejetada',
    descricao: 'Veículo capotado com teto colapsado e vazamento de gasolina. V1 ejetada a 3,4 m com TCE grave e V2 condutora suspensa pelo cinto.',
    vitimasRotulo: '2 vítimas (1 Vermelho, 1 Amarelo)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_3_CAPOTAMENTO),
  },
  {
    id: 'cenario-4',
    titulo: 'Cenário 4: Carro Sobre Outro Veículo',
    descricao: 'Carro superior encavalado sobre sedã inferior. Estabilização pesada com V-Struts apoiados no solo e Fita Catraca unindo os dois carros em monobloco preso.',
    vitimasRotulo: '2 vítimas (1 Vermelho, 1 Amarelo)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_4_CARRO_SOBRE_OUTRO),
  },
  {
    id: 'cenario-5',
    titulo: 'Cenário 5: Colisão com Duas Vítimas Estáveis',
    descricao: 'Sedã colidido contra defensa metálica com portas emperradas. Duas vítimas lúcidas com suspeita de TRM para retirada alinhada a 0°.',
    vitimasRotulo: '2 vítimas (2 Verdes)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_5_DUAS_ESTAVEIS),
  },
  {
    id: 'cenario-6',
    titulo: 'Cenário 6: Atropelamento e Choque em Poste',
    descricao: 'Colisão contra poste com cabo elétrico energizado caído na via. Pedestre no solo com sangramento exsanguinante em membro inferior.',
    vitimasRotulo: '1 vítima (Crítica / Hemorragia)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_6_ATROPELAMENTO),
  },
  {
    id: 'cenario-7',
    titulo: 'Cenário 7: Barreira de Proteção Rodoviária (45° a 15m)',
    descricao: 'Doutrina de segurança viária: caminhão de bombeiros em ângulo de 45° a 15m da zona de impacto, giroflex ativo, cone de transição e corredor reservado para a USA.',
    vitimasRotulo: '1 vítima + 2 Bombeiros (EPI / APH)',
    criarCena: () => copiarCenaTabletop(PRESET_CENARIO_7_BARREIRA_PROTECAO),
  },
  {
    id: 'complexo',
    titulo: 'Acidente complexo com obstrução',
    descricao: 'Colisão multi-veicular com carro capotado, tombado sobre ele, SUV e vítima ejetada.',
    vitimasRotulo: '5 vítimas (Multi-triagem)',
    criarCena: () => copiarCenaTabletop(PRESET_TABLETOP_COMPLEXO),
  },
]

export const obterPresetPorId = (id: string): PredefinicaoTabletop | undefined => {
  const mapaLegado: Record<string, string> = {
    'slide-49-50': 'cenario-1',
    'slide-51-52': 'cenario-2',
    'capotamento-ejetada': 'cenario-3',
    'carro-sobre-outro': 'cenario-4',
    'slide-53-54': 'cenario-5',
    'atropelamento-hemorragia': 'cenario-6',
  }
  const idNormalizado = mapaLegado[id] ?? id
  return PRESETS_TABLETOP.find((p) => p.id === idNormalizado)
}

export const criarPresetTabletopComplexo = (): CenaTabletop =>
  copiarCenaTabletop(PRESET_TABLETOP_COMPLEXO)

